document.addEventListener('DOMContentLoaded', () => {

    jQuery.validator.setDefaults({
        highlight: function (element: HTMLInputElement, errorClass, validClass) {
            // default function
            if (element.type === "radio") {
                this.findByName(element.name).addClass(errorClass).removeClass(validClass);
            } else {
                $(element).addClass(errorClass).removeClass(validClass);
            }
            // custom additions
            $(element).closest('.form-field').addClass(errorClass).removeClass(validClass);
        },
        unhighlight: function (element: HTMLInputElement, errorClass, validClass) {
            // default function
            if (element.type === "radio") {
                this.findByName(element.name).removeClass(errorClass).addClass(validClass);
            } else {
                $(element).removeClass(errorClass).addClass(validClass);
            }
            // custom additions
            $(element).closest('.form-field').removeClass(errorClass).addClass(validClass);
        },
    });

    $.ajaxSetup({
        cache: false,
        xhrFields: {
            withCredentials: true
        }
    });

    initialize();
});

function initialize() {

    if ($('form').length > 0) {
        $.validator.unobtrusive.parse("form");
    }

    $('input.input-validation-error').each((idx, elem) => {
        $(elem).closest('.form-field').addClass('input-validation-error');
    });

    $('input[data-type="autocomplete"]').each(function () {
        const $el: any = $(this);
        const source = $el.attr('data-source');
        console.log(JSON.parse(source));
        $el.autocomplete({
            source: JSON.parse(source),
            minLength: 0,
            appendTo: $(this).parent().parent().parent().parent(),
            select: function (event: any, ui: any) {
                console.log(ui.item.value);
                $(this).val(ui.item.value);
            }
        });
    });

    preventDoubleSubmit();
    initReCaptcha();
}

function beforeRequest(jqXhr: any, ajaxSettings: JQuery.Ajax.AjaxSettingsBase<any>) {
    const $form = $("form");
    if ((ajaxSettings.type.toUpperCase() === 'POST') && ($form.length > 0) && !$form.valid()) {
        return false;
    }

    $('#loader').addClass('fade-in');
    $('.page-body').addClass('page-body-loading');
    $('.panel-wrapper').css('opacity', 0.8);
    $('.panel-wrapper').css({ 'opacity': 1, 'pointer-events': 'none' });
}

const successRequest: JQuery.Ajax.SuccessCallback<any> = function (data, textStatus, jqXhr) {

    const redirectDestination = jqXhr.getResponseHeader('Location');
    if (redirectDestination) {
        window.location.replace(redirectDestination);
        return;
    }

    $('.panel-wrapper').addClass('slide-left')
        // .one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
        .one('animationend', function (e) {
            $(this).find('.brd-panel:first').remove();
            $(this).removeClass('slide-left');
            $('input[autofocus]').focus();
        });
}

const completeRequest: JQuery.Ajax.CompleteCallback<any> = function (jqXhr, textStatus) {
    if (jqXhr.status < 400) {
        initialize();
    }

    const redirectDestination = jqXhr.getResponseHeader('Location');
    if (!redirectDestination) {
        $('#loader').removeClass('fade-in');
        $('.page-body').removeClass('page-body-loading');
        $('.panel-wrapper').css({ 'opacity': 1, 'pointer-events': 'auto' });
    }
}

const failureRequest: JQuery.Ajax.ErrorCallback<any> = function (jqXhr, textStatus, errorThrown) {
    if (jqXhr.status === 400) {
        // Probabilmente si tratta di una bad request dovuta all'antiforgery token scaduto poiche' 
        // e' stata fatta la login da un altro tab
        location.reload();
    }
}

function onSubmitWithCaptcha() {
    if (typeof grecaptcha === 'undefined') {
        console.warn('ReCaptcha not initialized');
        return;
    }

    document.querySelector<HTMLButtonElement>(".captcha-invisible-submit-button")?.click();
}

function preventDoubleSubmit(): void {
    const FORM_SUBMITTED = 'BrdFormSubmitted';

    $('input[type=submit],button[type=submit]').click(function (ev) {
        var self = $(this);

        const form = self.closest('form');

        if (form.valid()) {
            if (form.data(FORM_SUBMITTED)) {
                console.info('Your form has been already submited. wait please');
                ev.preventDefault();
                return false;
            }
            else {
                form.data(FORM_SUBMITTED, 'true');
            }
        };
    });
}

function initReCaptcha() {
    if (typeof grecaptcha !== 'undefined') {
        const RECAPTCHA_INITIALIZED = 'BrdRecaptchaInitialized';

        const reCaptchaElement = document.querySelector<HTMLElement>(".g-recaptcha");
        if (reCaptchaElement && !reCaptchaElement.dataset[RECAPTCHA_INITIALIZED]) {
            grecaptcha.render(reCaptchaElement);
            reCaptchaElement.dataset[RECAPTCHA_INITIALIZED] = 'true';
        }
    }
}